var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.149902 4.14992C0.149902 4.49211 0.27781 4.81256 0.510129 5.05426L3.34756 8.00631C3.53158 8.19777 3.82916 8.19777 4.01188 8.00631C4.19591 7.81484 4.19591 7.50523 4.01188 7.31513L1.17445 4.36308C1.06482 4.24902 1.06482 4.05078 1.17445 3.93672L4.01188 0.984675C4.19591 0.793213 4.19591 0.483603 4.01188 0.293499C3.82785 0.102036 3.53028 0.102036 3.34756 0.293499L0.510129 3.24554C0.27781 3.48725 0.149902 3.80773 0.149902 4.14992Z",
    fill: "#F2ECE0",
    stroke: "#F2ECE0",
    strokeWidth: 0.3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.2d1d9ce08514af31434450558247a901.svg";
export { ForwardRef as ReactComponent };